import { render } from "./OutlineAnnouncement.vue?vue&type=template&id=94fa740c"
import script from "./OutlineAnnouncement.vue?vue&type=script&lang=js"
export * from "./OutlineAnnouncement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__